var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportanceFlag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 9.33333H26.1878C26.7842 9.33333 27.0824 9.33333 27.2568 9.45872C27.409 9.56813 27.5081 9.73652 27.5298 9.92266C27.5547 10.136 27.4099 10.3967 27.1203 10.918L25.3255 14.1486C25.2204 14.3377 25.1679 14.4323 25.1473 14.5324C25.1291 14.621 25.1291 14.7124 25.1473 14.801C25.1679 14.9011 25.2204 14.9956 25.3255 15.1847L27.1203 18.4153C27.4099 18.9367 27.5547 19.1973 27.5298 19.4107C27.5081 19.5968 27.409 19.7652 27.2568 19.8746C27.0824 20 26.7842 20 26.1878 20H16.8007C16.0539 20 15.6805 20 15.3953 19.8547C15.1444 19.7268 14.9405 19.5229 14.8126 19.272C14.6673 18.9868 14.6673 18.6134 14.6673 17.8667V14.6667M5.33399 28L5.33398 5.33333M5.33398 14.6667H16.534C17.2807 14.6667 17.6541 14.6667 17.9393 14.5213C18.1902 14.3935 18.3942 14.1895 18.522 13.9387C18.6673 13.6534 18.6673 13.2801 18.6673 12.5333V6.13333C18.6673 5.3866 18.6673 5.01323 18.522 4.72801C18.3942 4.47713 18.1902 4.27316 17.9393 4.14532C17.6541 4 17.2807 4 16.534 4H7.46732C6.72058 4 6.34721 4 6.062 4.14532C5.81111 4.27316 5.60714 4.47713 5.47931 4.72801C5.33398 5.01323 5.33398 5.3866 5.33398 6.13333V14.6667Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportanceFlag2);
export default __webpack_public_path__ + "static/media/ImportanceFlag2.e106f4e6cb47bcf7d69230efbeff7082.svg";
export { ForwardRef as ReactComponent };